<template>
  <page-view title="京喜团账户">
    <!-- <div :style="{ marginBottom: '10px' }">
      <demo-video-alert name="LianMengPeiZhi"></demo-video-alert>
    </div> -->

    <a-card :bordered="false">
      <!-- 查询 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="查询条件">
                <a-select v-model="queryParam.type" placeholder="请选择查询条件" allowClear>
                  <!-- <a-select-option value="1">账户ID</a-select-option>
                  <a-select-option value="2">京喜团账户</a-select-option> -->
                  <a-select-option value="3">备注信息</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="查询内容">
                <a-input v-model="queryParam.keywords" placeholder="请输入查询内容" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="授权状态">
                <a-select v-model="queryParam.status" placeholder="请选择授权状态" allowClear>
                  <a-select-option value="1">已授权</a-select-option>
                  <a-select-option value="2">已过期</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="table-operator">
        <a-button type="primary" @click="handleAdd">新增京喜团账户</a-button>
      </div>

      <s-table ref="table" size="default" rowKey="taobao_user_id" :columns="columns" :data="loadData">
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <!-- 账户id -->
        <span slot="xid" slot-scope="record">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ record.xid }}</span>
            </template>
            <span class="hiddenText">{{ record.xid }}</span>
          </a-tooltip>
        </span>
        <!-- 备注 -->
        <div slot="remarks_text" slot-scope="text, record">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ record.remark ? record.remark : '无' }}</span>
            </template>
            <span class="hiddenText">{{ record.remark ? record.remark : '无' }}</span>
          </a-tooltip>
        </div>
        <!-- 授权状态 -->
        <span slot="auth_status" slot-scope="record">
          <a-badge :status="record.expire_time | statusTypeFilter" :text="record.expire_time | statusFilter" />
        </span>
        <!-- 同步订单的开关 -->
        <span slot="is_sync" slot-scope="text, record">
          <a-switch checked-children="开" un-checked-children="关" :default-checked="text == 2"
            @change="handleSysChange($event, record)" />
        </span>
        <!-- 到期时间 -->
        <!-- <span slot="time" slot-scope="text">{{ parseInt(text) | moment }}</span> -->
        <!-- 操作 -->
        <span slot="action" slot-scope="text, record">
          <!-- <a @click="positionSync(record)">设置自定义推广位同步</a> -->
          <!-- <a-divider type="vertical" /> -->
          <a @click="handleRefresh(record.id)">更新</a>
          <a-divider type="vertical" />
          <a @click="$refs.editModal.show(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm placement="top" @confirm="handleDelete(record.id, record.xid)">
            <a-icon slot="icon" type="question-circle-o" style="color: red" />
            <template slot="title">
              <p>确定要删除？</p>
            </template>
            <a>删除</a>
          </a-popconfirm>
        </span>
      </s-table>

    </a-card>

    <edit-modal ref="editModal" @ok="$refs.table.refresh()"></edit-modal>
    <!-- 	设置自定义推广位同步 -->
    <custom-promotion-space ref="cpSpace"></custom-promotion-space>

  </page-view>
</template>

<script>
import { mapGetters } from 'vuex'
import CompanyApi from '@/api/company'

import { PageView } from '@/layouts'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
import { STable } from '@/components'
import EditModal from './modules/EditModal'
import CustomPromotionSpace from './modules/CustomPromotionSpace'

const statusMap = {
  1: {
    status: 'processing',
    text: '正常',
  },
  3: {
    status: 'error',
    text: '已过期',
  },
}

export default {
  name: 'CompanyJxtuanList',
  components: {
    PageView,
    DemoVideoAlert,
    STable,
    EditModal,
    CustomPromotionSpace,
  },

  data() {
    return {
      queryParam: {},
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        return CompanyApi.getJxtList(Object.assign(parameter, this.queryParam))
      },
      columns: [
        {
          title: '序号',
          width: 80,
          scopedSlots: { customRender: 'serial' },
        },,
        {
          title: '账户ID',
          width: 200,
          scopedSlots: { customRender: 'xid' }
        },
        {
          title: '授权状态',
          width: 100,
          scopedSlots: { customRender: 'auth_status' },
        },
        {
          title: '同步订单',
          width: 100,
          dataIndex: 'is_sync',
          scopedSlots: { customRender: 'is_sync' },
        },
        {
          title: '备注信息',
          scopedSlots: { customRender: 'remarks_text' },
        },
        // {
        //   title: '到期时间',
        //   scopedSlots: { customRender: 'time' },
        //   dataIndex: 'expire_time',
        //   sorter: true,
        // },
        {
          title: '操作',
          // width: '220px',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    }),
  },

  filters: {
    statusFilter(expire_time) {
      const curTimestamp = new Date().getTime()
      let type
      if (expire_time > curTimestamp) {
        type = 1
      } else {
        type = 3
      }
      return statusMap[type].text
    },
    statusTypeFilter(expire_time) {
      const curTimestamp = new Date().getTime()
      let type
      if (expire_time > curTimestamp) {
        type = 1
      } else {
        type = 3
      }
      return statusMap[type].status
    },
  },

  methods: {
    // 同步订单的开关
    async handleSysChange(e, record) {
      CompanyApi.setSysJxtuan({
        xid: record.xid,
        status: e ? 2 : 0,
      })
    },

    // 新增-京喜团账户授权
    handleAdd() {
      let state = this.userInfo.id
      window.open(
        `https://open-oauth.jd.com/oauth2/to_login?app_key=F3F73E602175D2ACE5E2D09DFD7A869B&response_type=code&redirect_uri=http://192.168.3.15:8090/api/644769b61e4e8&state=${state}&scope=snsapi_base`
      )
      const that = this
      this.$confirm({
        title: '请在新窗口中登录京东账户完成授权',
        okText: '已完成授权',
        cancelText: '关闭',
        onOk() {
          that.$refs.table.refresh(true)
        },
      })
    },

    // 更新-京喜团账户授权
    handleRefresh() {
      let state = this.userInfo.id
      window.open(
        `https://open-oauth.jd.com/oauth2/to_login?app_key=F3F73E602175D2ACE5E2D09DFD7A869B&response_type=code&redirect_uri=http://192.168.3.15:8090/api/644769b61e4e8&state=${state}&scope=snsapi_base`
      )
      const that = this
      this.$confirm({
        title: '请在新窗口中登录京东账户完成授权',
        okText: '已完成授权',
        cancelText: '关闭',
        onOk() {
          that.$refs.table.refresh()
        },
      })
    },

    // 设置自定义推广位同步
    positionSync(record) {
      // console.log('设置自定义推广位同步=', record)
      this.$refs.cpSpace.show(record)
    },

    handleDelete(id, xid) {
      let loading = this.$message.loading('正在删除')
      CompanyApi.jxtDelete({ 
        id: id ,
        xid: xid 
      })
        .then((res) => {
          if (res.code === 1) {
            this.$message.success('删除成功')
            this.$refs.table.refresh()
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.$message.destroy(loading)
        })
    },

  },
}
</script>

<style lang="less" scoped>
p {
  margin-bottom: 0;
}
.hiddenText {
  width: 220px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  top: 5px;
}
</style>
